import {
    type GetUploadTokenForDriveResponseType,
    type GetUploadTokenForDriveRequestType
} from "./type";
import {
    request
} from "../request";

const GetUploadTokenForDrive = async (params: GetUploadTokenForDriveRequestType): Promise<GetUploadTokenForDriveResponseType> => {
    return await request<GetUploadTokenForDriveResponseType>("/drive/getUploadTokenForDrive", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetUploadTokenForDrive;
